import { Icon } from '@/components'
import { useArcade } from '@/features/arcade/provider'
import { useArcadeSeasonStarts } from '@/features/arcade/hooks/countdown'

export const SeasonBegins = () => {
  const { season } = useArcade()
  const { seasonStarts } = useArcadeSeasonStarts({
    season,
    precision: 'medium'
  })

  return (
    <section className="body-sm border-gray-700 border-1 border-solid rounded-[16px] flex flex-col items-center gap-1 py-3 md:py-2">
      <div className="text-gray-300">{season?.name} Begins</div>
      <div className="flex items-center text-gray-300 body-sm">
        <div className="text-white font-bold flex gap-[4px] items-center">
          <Icon name="timer" className="w-2 h-2" />
          <span className="tabular-nums">{seasonStarts?.formatted}</span>
        </div>
      </div>
    </section>
  )
}
